import React, { useState } from "react";
import WaitlistTable from "./Tables/WaitlistTable";
import AddToWaitlistField from "./Fields/AddToWaitlistField";
import WaitlistModal from "./Modals/WaitlistModal";

interface GameInfo {
  id: string;
  [key: string]: any;
}

interface WaitlistSectionProps {
  gameInfo: GameInfo;
}

const WaitlistSection: React.FC<WaitlistSectionProps> = ({ gameInfo }) => {
  const [modalDets, setModalDets] = useState({
    open: false,
    status: "",
    reqData: {},
  });

  return (
    <div>
      <h2>Waitlist</h2>
      <WaitlistModal dets={modalDets} gameInfo={gameInfo} />
      <AddToWaitlistField gameInfo={gameInfo} setModalDets={setModalDets} />
      <WaitlistTable gameInfo={gameInfo} setModalDets={setModalDets} />
    </div>
  );
};

export default WaitlistSection;
